export const documentViewerConfig = {
    documentsApiUrl: 'https://demo.fortrus.com/doc-api/',
    documentUploadOn: true,
    documentUploadDocumentClassEnable: false,
    uncancelAttendancesModule: true,
    uncancelAttendanceFilter: "canceled eq true and incomingSystem eq 'PCS'",
    TrudUploadModule: true,
    uploadFields: {
        docDate: {
            visible: true,
            required: true,
            defaultValue: Date.now(),
        },
        docTime: {
            visible: true,
            required: true,
            defaultValue: Date.now(),
        },
        docType: {
            visible: true,
            required: true,
        },
        docClass: {
            visible: true,
        },
        recordType: {
            visible: true,
        },
        accessRole: {
            visible: true,
            required: true,
            documentUploadAccessKeyCloakRoles: [
                {
                    role: 'lwh-fhc-genetic',
                    default: false,
                },
                {
                    role: 'lwh-fhc-general',
                    default: 'error',
                },
                {
                    role: 'stg-fhc-general',
                },
                {
                    role: 'lwh-fhc-hfc',
                },
                {
                    role: 'Enquiries',
                    default: true,
                },
                {
                    role: 'manage-account',
                },
                {
                    role: 'manage-account-links',
                },
                {
                    role: 'view-profile',
                },
                {
                    role: 'CAN_ACCESS_ADMIN_PAGE',
                },
                {
                    role: 'CAN_DOWNLOAD_DOCUMENT',
                },
                {
                    role: 'CAN_ACCESS_DICTIONARIES',
                },
                {
                    role: 'CAN_CREATE_ADMISSIONS',
                },
                {
                    role: 'CAN_SEE_HIDDEN_DOCUMENTS',
                },
                {
                    role: 'CAN_ACCESS_HL7DASHBOARD',
                },
                {
                    role: 'CAN_BREAKGLASS_LV_1',
                },
                {
                    role: 'CAN_BREAKGLASS_LV_2',
                },
                {
                    role: 'CAN_BREAKGLASS_LV_3',
                },
                {
                    role: 'demo-access-doc',
                },
            ],
        },
        storage: {
            visible: true,
            required: true,
            uploadSources: [
                { name: 'UNITY STORE', code: 'SRC_UNITYSTORE', default: true },
                { name: 'DCTM', code: 'SRC_DCTM' },
            ],
        },
        attendance: {
            visible: true,
        },
        taskId: {
            visible: true,
        },
        altAttendance: {
            visible: true,
        },
        referral: {
            visible: true,
        },
    },
};
